import { atom } from "recoil";

import { PaymentResultType } from "components/Common";
import { OrderDto } from "graphql/generated";
import { EvalFlowPriceSelectionVariant } from "src/types";

import keys from "./constants";

export const isRenewalModalOpenedState = atom<boolean>({
  key: keys.IS_RENEWAL_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const variantEditState = atom<EvalFlowPriceSelectionVariant>({
  key: keys.VARIANT_EDIT_STATE,
  default: null
});

export const renewalSelectedProductState = atom<any>({
  key: keys.RENEWAL_SELECTED_PRODUCT_STATE,
  default: null
});

export const isRenewalAddingModalAddingState = atom<boolean>({
  key: keys.IS_RENEWAL_MODAL_ADDING_STATE,
  default: false
});

export const selectedTreatmentState = atom<OrderDto>({
  key: keys.SELECTED_TREATMENT_STATE,
  default: null
});

export const isEditModalOpenedState = atom<boolean>({
  key: keys.IS_EDIT_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const editSelectedProductState = atom<any>({
  key: keys.EDIT_SELECTED_PRODUCT_STATE,
  default: null
});

export const isDeliveryEditModalOpenedState = atom<boolean>({
  key: keys.IS_DELIVERY_EDIT_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const isConsultEditModalOpenedState = atom<boolean>({
  key: keys.IS_CONSULT_EDIT_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const isDeliveryDetailsModalOpenedState = atom<boolean>({
  key: keys.IS_DELIVERY_DETAILS_MODAL_OPENED_STATE,
  default: false
});

export const isFailPaymentModalOpenedState = atom<boolean>({
  key: keys.IS_FAIL_PAYMENT_MODAL_OPENED_STATE,
  default: false
});

export const renewResultModalState = atom<{
  isOpen: boolean;
  resultType: PaymentResultType;
}>({
  key: keys.RENEW_RESULT_MODAL_STATE,
  default: {
    isOpen: false,
    resultType: null
  }
});
